import type { ValuationOverview as ValuationOverviewSchema } from '@einwert/valuation-api-client'

import { Box, Stack } from '@mui/material'
import { MonetaryValue, tokens, TrendIcon } from 'ComponentLibrary'
import Typography from 'ComponentLibrary/src/piazza/text/Typography/Typography'
import { useTranslation } from 'react-i18next'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'

type MarketValueInfoCellProps = {
    valuation: ValuationOverviewSchema
}

export const MarketValueInfoCell = ({ valuation }: MarketValueInfoCellProps) => {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const locale = useCurrentResolvedLocale()

    return (
        <Stack direction="row" gap={tokens.SizingSpacing200} alignItems="center" width="200px" justifyContent="flex-end">
            <Box width="136px" display="flex" height="100%">
                <Stack direction="column" width="100%" alignItems="flex-end">
                    <Typography variant="headline4" color={tokens.ColorTextBoldest}>
                        {MonetaryValue.fromMonetaryValueDataObject(valuation.market_value.value).format({
                            withoutDecimals: true,
                            locale,
                        })}
                    </Typography>
                    <Typography variant="textS" color={tokens.ColorTextDefault}>
                        {tCommon('marketValue')}
                    </Typography>
                </Stack>
            </Box>
            {valuation.market_value.trend !== undefined && (
                <Box width="70px" display="flex" justifyContent="flex-end">
                    <TrendIcon variant="label" trend={valuation.market_value.trend} locale={locale} />
                </Box>
            )}
        </Stack>
    )
}
